import { RulesConstants } from '../RulesConstants';
export class RuleUtilsService {
    static convertExtras(property) {
        let extrasProperty = property;
        if (property?.includes(RulesConstants.EXTRAS)) {
            const tokens = extrasProperty.split('.').slice(2);
            extrasProperty = tokens.join('.');
        }
        return extrasProperty;
    }
    static serializeExtrasProperies(property) {
        return `Contact.Extras.${property}`;
    }
}
